/**
 * Row of three KPI cards for dashboard statistics.
 * Shows active listings, pending listings, and team count.
 */

import { useTranslation } from 'react-i18next';
import { Home, Clock, Users } from 'lucide-react';
import { KPICard } from './KPICard';

interface KPIRowProps {
  activeListings: number;
  pendingListings: number;
  totalAgents: number;
  onAgentsClick?: () => void;
}

export function KPIRow({
  activeListings,
  pendingListings,
  totalAgents,
  onAgentsClick,
}: KPIRowProps) {
  const { t } = useTranslation('dashboard');

  return (
    <div className="grid grid-cols-3 gap-3">
      <KPICard
        title={t('company.kpiCards.active')}
        value={activeListings}
        icon={<Home className="h-6 w-6 text-emerald-600" />}
        colorClass="bg-emerald-50"
      />
      <KPICard
        title={t('company.kpiCards.pending')}
        value={pendingListings}
        icon={<Clock className="h-6 w-6 text-amber-600" />}
        colorClass="bg-amber-50"
      />
      <KPICard
        title={t('company.kpiCards.team')}
        value={totalAgents}
        icon={<Users className="h-6 w-6 text-[#004D40]" />}
        colorClass="bg-[var(--pv-color-surface-sunken)]"
        onClick={onAgentsClick}
      />
    </div>
  );
}
